var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"dense":"","outlined":"","hide-details":"","background-color":"white","clearable":"","items":_vm.items,"placeholder":_vm.$t('typ')}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }